import { instanceAxiosPrivate } from "../../axios";
import { toast } from "react-toastify";

import {
  setrtefuente,
  setLoadingCert,
  setrteica,
  setrteiva,
  setPeriodos,
  setCiudades,
  setTipocertificado,
  setYears,
} from "./certificadosSlice";

export const periodos = (e) => {
  return async (dispatch, getState) => {
    try {
      const instAxiosPrivate = new instanceAxiosPrivate();
      const { data } = await instAxiosPrivate.services.get(
        `/v1/certificaciones/getperiodos`,
        {
          params: {
            periodicity: e.periodicity || null,
          },
        }
      );
      dispatch(setPeriodos(data));
      dispatch(setLoadingCert(false));
    } catch (error) {
      toast.error(error.message);
    }
  };
};

export const ciudades = (e) => {
  return async (dispatch, getState) => {
    try {
      const instAxiosPrivate = new instanceAxiosPrivate();
      const { data } = await instAxiosPrivate.services.get(
        `/v1/certificaciones/getciudades`,
        {
          params: {
            city: e.city || "" || null,
            nom_ciudad: e.nom_ciudad || "" || null,
          },
        }
      );
      dispatch(setCiudades(data));
      dispatch(setLoadingCert(false));
    } catch (error) {
      toast.error(error.message);
    }
  };
};

export const years = (e) => {
  return async (dispatch, getState) => {
    try {
      let getCurrentYear = new Date().getFullYear(); // current year
      let listOfYears = Array.from(
        { length: 11 },
        (_, i) => getCurrentYear - i
      );
      dispatch(setYears(listOfYears));
      dispatch(setLoadingCert(false));
    } catch (error) {
      toast.error(error.message);
    }
  };
};

export const tipocertificado = (e) => {
  return async (dispatch, getState) => {
    try {
      const instAxiosPrivate = new instanceAxiosPrivate();
      const { data } = await instAxiosPrivate.services.get(
        `/v1/certificaciones/gettipocertificado`
      );
      dispatch(setTipocertificado(data));
      dispatch(setLoadingCert(false));
    } catch (error) {
      toast.error(error.message);
    }
  };
};

export const rtefuenteProveedor = (e) => {
  return async (dispatch, getState) => {
    try {
      dispatch(setLoadingCert(true));
      const instAxiosPrivate = new instanceAxiosPrivate();
      const { data } = await instAxiosPrivate.services.get(
        `/v1/certificaciones/getrtefuente`,
        {
          params: {
            vigencia: e.vigencia || null,
          },
        }
      );
      dispatch(setrtefuente(data));
      dispatch(setLoadingCert(false));
    } catch (error) {
      //console.log('error message api', error.message);
      dispatch(setLoadingCert(false));
      toast.error(error.message);
    }
  };
};

export const rtefuenterangeProveedor = (e) => {
  return async (dispatch, getState) => {
    try {
      dispatch(setLoadingCert(false));
      const instAxiosPrivate = new instanceAxiosPrivate();
      const { data } = await instAxiosPrivate.services.get(
        `/v1/certificaciones/getrtefuenterange`,
        {
          params: {
            vigencia: e.vigencia || null,
          },
        }
      );
      dispatch(setrtefuente(data));
      dispatch(setLoadingCert(false));
    } catch (error) {
      dispatch(setLoadingCert(false));
      toast.error(error.message);
    }
  };
};

export const rteicaProveedor = (e) => {
  return async (dispatch, getState) => {
    try {
      dispatch(setLoadingCert(false));
      const instAxiosPrivate = new instanceAxiosPrivate();
      const { data } = await instAxiosPrivate.services.get(
        `/v1/certificaciones/getrteica`,
        {
          params: {
            vigencia: e.vigencia || null,
          },
        }
      );
      dispatch(setrteica(data));
      dispatch(setLoadingCert(false));
    } catch (error) {
      //console.log('error message api', error.message);
      dispatch(setLoadingCert(false));
      toast.error(error.message);
    }
  };
};

export const rteicarangeProveedor = (e) => {
  return async (dispatch, getState) => {
    try {
      dispatch(setLoadingCert(false));
      const instAxiosPrivate = new instanceAxiosPrivate();
      const { data } = await instAxiosPrivate.services.get(
        `/v1/certificaciones/getrteicarange`,
        {
          params: {
            vigencia: e.vigencia || null,
            type_cert: e.type_cert || null,
            periodo: e.periodo || null,
            ciudad: e.ciudad || null,
          },
        }
      );
      dispatch(setrteica(data));
      dispatch(setLoadingCert(false));
    } catch (error) {
      dispatch(setLoadingCert(false));
      toast.error(error.message);
    }
  };
};

export const rteivaProveedor = (e) => {
  return async (dispatch, getState) => {
    try {
      dispatch(setLoadingCert(false));
      const instAxiosPrivate = new instanceAxiosPrivate();
      const { data } = await instAxiosPrivate.services.get(
        `/v1/certificaciones/getrteiva`,
        {
          params: {
            vigencia: e.vigencia || null,
          },
        }
      );
      dispatch(setrteiva(data));
      dispatch(setLoadingCert(false));
    } catch (error) {
      //console.log('error message api', error.message);
      dispatch(setLoadingCert(false));
      toast.error(error.message);
    }
  };
};

export const rteivarangeProveedor = (e) => {
  return async (dispatch, getState) => {
    try {
      dispatch(setLoadingCert(false));
      const instAxiosPrivate = new instanceAxiosPrivate();
      const { data } = await instAxiosPrivate.services.get(
        `/v1/certificaciones/getrteivarange`,
        {
          params: {
            vigencia: e.vigencia || null,
            type_cert: e.type_cert || null,
            periodo: e.periodo || null,
            ciudad: e.ciudad || null,
          },
        }
      );
      dispatch(setrteiva(data));
      dispatch(setLoadingCert(false));
    } catch (error) {
      dispatch(setLoadingCert(false));
      toast.error(error.message);
    }
  };
};

export const getCertificado = (e) => {
  return async (dispatch, getState) => {
    try {
      const xhr = new instanceAxiosPrivate();
      //generate excel
      const { data:respExcel } = await xhr.services.get(`/v1/certificaciones/getexcel`,
        {params: e }
      )
      //get data pdf
      const { data:respDataPDF } = await xhr.services.get(`/v1/certificaciones/getpdfdata`,
        { params: e }
      )
      //get pdf
      const { data } = await xhr.services.post(`/v1/generatepdf`, respDataPDF.dataPDF, {
        headers: { "Content-Type": "application/json" },
      });
      //zip file
      const { data: zip } =  await xhr.services.get(`/v1/certificaciones/generatezip`, {
        params: {
          "pdf": data.url,
          "excel": respExcel.urlExcel,
          "folder": "upload",
          "nit": e.nit,
          "bimestre": e.bimestre
        } 
      });
      let newTab = document.createElement("a");
      newTab.href = process.env.REACT_APP_ENDPOINT + zip.url;
      newTab.target = "_blank";
      newTab.click();
    } catch ({response}) {
      let respe = response.data.error === "Data not found" ? "No hay datos" : response.data.error;
      toast.error(respe);
    }
  };
};
